export default {
  // tank-type data which gets initialized during AppInit & used by the whole app
  tankTypes: []
}
